module.exports = __webpack_public_path__ + "static/media/cover-2-lg.7d439f42.png";